angular.module('fef', [
]);

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefColspan', FefColspan);
    /**
     * @ngdoc directive
     * @name fefColspan
     *
     * @param {expression} fefColspan The main argument is the value of the colspan you want to bind to.
     *
     * @description
     * Sets the colspan attribute on the attached element to the value of the evaluated main argument.
     * This is useful only in that it does not cause html validation errors, as would setting
     * colspan="{{interpolated expression}}" which would do the same thing.
     */
    function FefColspan() {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var _updateView = function() {
                    element.attr('colspan', scope.$eval(attrs.fefColspan));
                };
                scope.$watch(attrs.fefColspan, _updateView);
                _updateView();
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefEnter', FefEnter);
    /**
     * @ngdoc directive
     * @name fefEnter
     *
     * @param {expression} fefEnter the main argument is an expression to evaluate.
     *
     * @description
     * Binds keydown events for key 13 (The enter key) to the evaluation of the
     * main argument as an expression on scope. Used in our directives, for
     * instance, to open/close a dropdown when the user presses enter.
     */
    function FefEnter() {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var expression = attrs.fefEnter;
                element.on('keydown', function(event) {
                    if (event.which === 13) {
                        scope.$apply(function() {
                            scope.$eval(expression);
                        });
                        // Cancel any further event propegation
                        return false;
                    }
                    return true;
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefFocusOnEvent', FefFocusOnEvent);

    FefFocusOnEvent.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefFocusOnEvent
     * @requires fef.Utils
     * @param {expression} fefFocusOnEvent the main argument is an expression to evaluate.
     *
     * @directive
     * Directive to listen for an event on scope (specified as an argument)
     * and focus the element whenever the event fires. Does a $scope.$on on
     * the element's scope, given the main argument as the event name, and
     * gives the element focus when that event occurs. $broadcast that event
     * from the element's scope (or one of its parent scopes), or $emit it from
     * a child scope under the element, to cause the element to gain focus.
     */
    function FefFocusOnEvent(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var eventName = attrs.fefFocusOnEvent;
                var focused = false;
                if (!utils.exists(eventName)) {
                    throw new Error('fefFocusOnEvent requires an event argument');
                }

                scope.$on(eventName, function() {
                    focused = false;
                    element.bind('focus', function(event) {
                        focused = true;
                        element.unbind(event);
                    });

                    element.focus();

                    // If we are in a headless browser, focus() won't do anything. But we still want to fire the events.
                    // So, if the focus event hasn't yet been fired, do that here.
                    if (!focused) {
                        element.triggerHandler('focus');
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefFormatOnBlur', FefFormatOnBlur);

    FefFormatOnBlur.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefFormatOnBlur
     * @requires ng.ngModel
     * @requires fef.Utils
     * @priority 10
     * @param {expression=} fef-format-on-blur-change an expression to evaluate at the time of the blur event
     *  if and only if a model change occurred between the previous focus event and the blur event.
     *
     * @description
     * Binds to the blur event and works with ngModel to reformat the view value after a blur. Useful in cases where
     * a value converter directive accepts multiple input formats that are different from the output format (e.g. dates).
     * Also, this directive filters ngChange events to just those in which the model value is valid, and upon blur -
     * remembers the initial value or the last valid value and restores that value if the model value is invalid at the
     * time of the blur. This behavior was included in this directive due to event timing difficulties in making them
     * separate directives.
     */
    function FefFormatOnBlur(utils) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            priority: 10,
            link: function postLink(scope, element, attrs, ctrl) {
                // optional onChange expression for ngChange at blur time
                var onChangeAtBlur = attrs.fefFormatOnBlurChange;

                // preserve the value at time of focus
                var originalValue;
                var originalInvalid;

                // this parser reverts the model value to the
                // original value at the time of focus if the current
                // value is invalid. This filters ng-change and model
                // value pushes from ngModel to only valid values (or the original
                // value prior to binding)
                ctrl.$parsers.push(function(input) {
                    if (ctrl.$invalid) {
                        return originalValue;
                    }
                    return input;
                });

                // when we receive focus, capture the current $viewValue
                element.bind('focus', function() {
                    originalValue = ctrl.$modelValue;
                    originalInvalid = ctrl.$invalid;
                });

                // when we lose focus, revert to old value if new value is invalid,
                // then reformat the view.
                element.bind('blur', function() {
                    var i;
                    scope.$digest(); // JEB: do we need this?

                    // re-run the formatter chain on the $modelValue
                    ctrl.$viewValue = ctrl.$modelValue;
                    for (i = ctrl.$formatters.length - 1; i >= 0; i = i - 1) {
                        ctrl.$viewValue = ctrl.$formatters[i](ctrl.$viewValue);
                    }

                    // reset the validity
                    if (angular.isDefined(originalInvalid) && !originalInvalid) {
                        angular.forEach(ctrl.$error, function(p, k) {
                            ctrl.$setValidity(k, true);
                        });
                    }

                    // re-render the view
                    ctrl.$render();

                    // if there is an onChangeAtBlur expression specified
                    // and the original value doesn't equal the current value
                    // then evaluate the expression.
                    if (utils.exists(onChangeAtBlur) &&
                        !angular.equals(originalValue, ctrl.$modelValue)) {
                        scope.$apply(onChangeAtBlur);
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefMaxlength', FefMaxlength);

    FefMaxlength.$inject = ['fef.Utils']
        /**
         * @ngdoc directive
         * @name fefMaxlength
         * @requires fef.Utils
         * @param {expression} fefMaxlength the main argument is an expression which is evaluated to a
         *  number or string (containing an un-formatted number).
         *
         * @description
         * Unlike the angular directive (or argument to the ngInput directive),
         * this directive actually adds the "maxlength" attribute to the element.
         * To remove the attribute, the expression should evaluate to null,
         * undefined, or a blank string.
         */
    function FefMaxlength(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var _updateView = function() {
                    var value = scope.$eval(attrs.fefMaxlength);
                    if (utils.exists(value)) {
                        value = value.toString();
                    }
                    if (utils.stringIsNonBlank(value)) {
                        element.attr('maxlength', scope.$eval(attrs.fefMaxlength).toString());
                    } else {
                        element.removeAttr('maxlength');
                    }
                };
                scope.$watch(attrs.fefMaxlength, _updateView);
                _updateView();
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefTabStop', FefTabStop);

    FefTabStop.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefTabStop
     * @restrict A
     * @requires fef.Utils
     *
     * @param {expression} fefTabStop The main argument is the expression to evaluate,
     * which should evaluate to a truthy or falsy value.
     *
     * @description
     * This directive is a simple on/off switch for tab-stop. If expression evaluates to truthy, then the tabindex
     * attribute is removed from the element. If it evaluates to falsy, then the tabindex attribute is added to the
     * element with a value of -1 (i.e. the element is skipped). This directive assumes you are using the browser
     * to determine tab-order automatically.
     */
    function FefTabStop(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                scope.$watch(attrs.fefTabStop, function(value) {
                    var result = utils.toBoolean(value);

                    if (result) {
                        attrs.$set('tabindex', undefined);
                    } else {
                        attrs.$set('tabindex', '-1');
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';

    /**
     * @ngdoc filter
     * @name <%= _.camelize(appname) %>.filter:<%= _.camelize(name) %>
     * @function
     * @description
     * # <%= _.camelize(name) %>
     * Filter in the <%= _.camelize(appname) %>.
     */
    angular.module('fef')
        .filter('fefMaxchars', FefMaxchars);

    function FefMaxchars() {
        var filter = function(input, numMaxChars) {
            var numMaxCharsInt = parseInt(numMaxChars, 10);
            if (input.length > numMaxCharsInt) {
                return input.substr(0, numMaxCharsInt) + '...';
            } else {
                return input;
            }
        };
        return function(input, numMaxChars) {
            return filter(input, numMaxChars);
        };
    }
}());

(function() {
    'use strict';

    /**
     * @ngdoc filter
     * @name fefOrElse
     *
     * @param {string} fefOrElse The main argument is a fallback value to use if the input is null or
     * undefined.
     *
     * @description:
     * Will return input, unless input is undefined or null, in which case
     * the argument (the fallback value) is returned.
     *
     * @example
       <example>
         <file name="index.html">
           <input data-ng-model="value" data-ng-init="value = null" /><br />
           <h1>value with filter: {{value | fefOrElse:'default value'}}</h1>
         </file>
       </example>
       <h1>{{data.name | fefOrElse:'Unknown'}}</h1>
     */
    angular.module('fef')
        .filter('fefOrElse', FefOrElse);

    function FefOrElse() {
        var filter = function(input, fallBackValue) {
            if (typeof input === 'undefined' || input === null) {
                return fallBackValue;
            } else {
                return input;
            }
        };
        return function(input, fallBackValue) {
            return filter(input, fallBackValue);
        };
    }
}());
(function () {
    'use strict';

    angular.module('fef')
        .service('fef.dataBindingUtils', DataBindingUtils);
    DataBindingUtils.$inject = ['$parse'];
    function DataBindingUtils ($parse) {
        this.makeOnChangeFuncWithHistory = function (scope, expression, listener) {
            var oldValue;
            var expressionFunc = $parse(expression);
            var updateOldValue = function() {
                oldValue = angular.copy(expressionFunc(scope));
            };

            updateOldValue();

            scope.$watch(expression, function(_oldValue, _newValue) {
                if (!angular.equals(_oldValue, _newValue)) {
                    updateOldValue();
                }
            });

            return function() {
                try {
                    listener(expressionFunc(scope), oldValue);
                } finally {
                    updateOldValue();
                }
            };
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('DeprecatedNoticeService', DeprecatedNoticeService);
    DeprecatedNoticeService.$inject = [];

    function DeprecatedNoticeService() {
        this.notify = function(deprecatedComponent, replacementComponent) {
            return 'The ' + deprecatedComponent +
                ' has been deprecated. Please use the ' +
                replacementComponent +
                ' directive available in the Bento Modern' +
                'Toolset: http://modern.centralux.int.thomsonreuters.com:8888';

        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.EmailService', EmailService);
    EmailService.$inject = [];

    function EmailService() {
        this.validate = function(email) {
            var emailTest = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!email) { //test for empty
                return 'Email cannot be empty.';
            } else if (!emailTest.test(email)) //test for valid format
            {
                return 'Email format is not valid.';
            } else {
                return true;
            }

        };
    }

}());

(function () {
	'use strict';
	angular.module('fef')
		.provider('fefLog', FefLogProvider);

	function FefLogProvider() {
		var _$log;

		var levels = ['none', 'error', 'warn', 'info', 'log', 'debug'];
		var baseConfig = {
			rootname : 'fef',
			consoleThreshold: 4,
			consoleTimestamp: false,
			httpThreshold: 1,
			httpPath: null,
			httpAuthorization: null,
			delay: 250
		};
		var rootGuid = trmrguid();
		var namedConfigs = {};
		var $window, $location;

		function setInit(_window, _location, _log) {
			$window = _window;
			$location = _location;
			_$log = _$log || _log
		}

		function thresholdFromString(value) {
			var i;
			for (i = 0; i < levels.length; i++) {
				if (levels[i] == value.toLowerCase()) {
					return i;
				}
			}

			return -1;
		}

		function validateConfig(config) {
			if (typeof config.consoleThreshold == 'string') {
				config.consoleThreshold = thresholdFromString(config.consoleThreshold);
			}
			if (typeof config.consoleThreshold != 'number' || config.consoleThreshold < 0 || config.consoleThreshold > 5) {
				config.consoleThreshold = 4;
			}

			if (typeof config.httpThreshold == 'string') {
				config.httpThreshold = thresholdFromString(config.httpThreshold);
			}
			if (typeof config.httpThreshold != 'number' || config.httpThreshold < 0 || config.httpThreshold > 5) {
				config.httpThreshold = 1;
			}
		}
		// won't allow new properties tp pollute config object
		function extendConfig(base, extended) {
			var keys = Object.keys(base);
			angular.forEach(keys, function (item) {
				// check for undefined explicitly so 0 and false will work
				if (extended[item] !== undefined) {
					base[item] = extended[item];
				}
			});
		}
		function configure(newConfig, name) {
			var cfg, key;

			if (!angular.isUndefined(newConfig)) {
				if (name && name.length) {
					key = ([baseConfig.rootname].concat(name)).join(':');
					cfg = namedConfigs[key];
					if (!cfg) {
						cfg = namedConfigs[key] = {
							consoleThreshold: baseConfig.consoleThreshold,
							httpThreshold: baseConfig.httpThreshold
						};
					}

					if (newConfig === null) {
						delete namedConfigs[key];
						cfg = baseConfig;
					} else {
						// will only override consoleThreshold & httpThreshold
						extendConfig(cfg, newConfig);
						validateConfig(cfg);
					}

					// return clone of configuration object
					return angular.extend({}, baseConfig, cfg);

				} else {
					extendConfig(baseConfig, newConfig);
					validateConfig(baseConfig);
				}
			}

			// return clone of configuration object
			return angular.extend({}, baseConfig);
		}

		/*jshint bitwise: true*/
		function trmrguid() {
			return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		}

		function generatePageGuid($http, pagename) {
			rootGuid = trmrguid();
			$http.defaults.headers.common['x-cobalt-pcid'] = rootGuid;

			var data = createLogData(baseConfig.rootname);
			data.level = 'page';
			data.pageName = (typeof pagename == 'string' ? pagename : 'UNKNOWN');
			logHttp(data);
		}

		var logBuffer = [];
		function logHttp(logData) {
			if (baseConfig.httpPath) {
				if (logBuffer.length == 0) {
				//*** DO NOT COPY THE PATTERN BELOW
					// use setTimeout/XMLHttpRequest instead of $timeout/$http to avoid circular exceptions/errors
					setTimeout(function () {
						var logRequest = new XMLHttpRequest();
						logRequest.open('POST', baseConfig.httpPath);
						logRequest.setRequestHeader('x-cobalt-pcid', rootGuid);
						logRequest.setRequestHeader('Content-Type', 'application/json'); // ;charset=UTF-8
						if (baseConfig.httpAuthorization) {
							logRequest.setRequestHeader('Authorization', baseConfig.httpAuthorization);
						}
						logRequest.send(JSON.stringify({version: '0.1', items: logBuffer}));

						logBuffer = [];
					}, baseConfig.delay);
				//***
				}
				logBuffer.push(logData);
			}
		}

		function createLogData (name) {
			var timestamp = (new Date()).toISOString();

			var data = {
				root: rootGuid,
				name: name,
				timestamp: timestamp
			};
			if ($location) {
				data['url'] = $location.absUrl();
			}

			return data;
		}

		// from angular.js source code
		function formatError(arg) {
			if (arg instanceof Error) {
				if (arg.stack) {
					arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
						? 'Error: ' + arg.message + '\n' + arg.stack
						: arg.stack;
				} else if (arg.sourceURL) {
					arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
				}
			}
			return arg;
		}

		function executeLogFn(args, logFn, level, name) {
			name = ([baseConfig.rootname].concat(name)).join(':');
			var logData = createLogData(name);
			var cfg = namedConfigs[name] || baseConfig;
			var timestamp = '';

			// HTTP logging
			if (baseConfig.httpPath && level <= cfg.httpThreshold) {
				var i, messages = [];
				for (i = 0; i < args.length; i++) {
					messages.push(args[i].toString());
				}

				logData.level = levels[level];
				logData.messages = messages;

				if (args[0] instanceof Error && $window.printStackTrace) {
					// requires stacktrace.js
					//logData['stacktrace'] = $window.printStackTrace({e: args[0]});
				}

				if (args[0] instanceof Error) {
					if (args[0].stack) {
						logData['stacktrace'] = formatError(args[0]);
					}
				}

				logHttp(logData);
			}

			// console logging
			if (level <= cfg.consoleThreshold) {

				// prepend an ISO timestamp and logger to the original log message
				if (cfg.consoleTimestamp) {
					timestamp = logData.timestamp + ' ';
				}
				if (angular.isString(args[0])) {
					args[0] = timestamp + '[' + name + '] ' + args[0];
				} else {
					args.unshift(timestamp + '[' + name + '] ');
				}

				logFn.apply(null, args);
			}
		}

		/**
		 * Wrap original log function
		 */
		function wrapLogFn(logFn, level, name) {
			var wrappedLogFn = function () {
				var args = Array.prototype.slice.call(arguments);
				return executeLogFn(args, logFn, level, name || ['$log']);
			};

			// support angular-mocks which assumes log messages captured in an array
			// https://github.com/angular/bower-angular-mocks/blob/master/angular-mocks.js
			wrappedLogFn.logs = [ ];

			return wrappedLogFn;
		}

		/**
		 * Generate name-specific logger instance
		 */
		function getLogger() {
			var name = Array.prototype.slice.call(arguments) || [];

			return {
				log: wrapLogFn(_$log.log, 4, name),
				info: wrapLogFn(_$log.info, 3, name),
				warn: wrapLogFn(_$log.warn, 2, name),
				debug: wrapLogFn(_$log.debug, 5, name),
				error: wrapLogFn(_$log.error, 1, name)
			};
		}

		this.enhance$log = function ($log, moduleName) {
			// capture the original functions of $log
			_$log = (function ($log) {
				return {
					log: $log.log,
					info: $log.info,
					warn: $log.warn,
					debug: $log.debug,
					error: $log.error
				};
			})($log);

			$log.debug = wrapLogFn($log.debug, 5);
			$log.log = wrapLogFn($log.log, 4);
			$log.info = wrapLogFn($log.info, 3);
			$log.warn = wrapLogFn($log.warn, 2);
			$log.error = wrapLogFn($log.error, 1);

			return $log;
		};

		this.$get = ['$window','$location', '$http', '$log', function ($window, $location, $http, $log) {
			var fefLog = {};

			setInit($window, $location, $log);

			fefLog.configure = configure;

			fefLog.getLogger = getLogger;

			fefLog.pageguid = function (pagename) {
				if (pagename) {
					generatePageGuid($http, pagename);
				}

				return rootGuid;
			};
/*
	// FUTURE usage concept - need to design a well behaved promise based API
			fefLog.component = function (options, promise) {
				var then = Date.now();
				var data = createLogData(baseConfig.rootname);
				delete data.url;
				data.componentName = options.name;
				data.level = 'component';
				return promise.then(function(result) {
					data.duration = (Date.now() - then);
					logHttp(data);
					return result;
				}, function(reason) {
					data.duration = (Date.now() - then);
					data.error = 1;
					logHttp(data);
					return reason;
				});
			};
*/
			return fefLog;
		}];
	}
})();
(function() {
    'use strict';
    angular.module('fef')
        .provider('fefLogger', FefLogProvider);
    function FefLogProvider() {
        var config = {
            consoleThreshold: 4,
            httpThreshold: 1,
            httpDomain: undefined,
            httpPath: '/demo/logs',
            delay: 250
        };
        var resource;

        var rootname = 'fef';
        var rootGuid = trmrguid();
        var $window, $location;

        function setInit(_window, _location) {
            $window = _window;
            $location = _location;
        }
        function formatError(arg, name) {
            if (arg instanceof Error) {
                if (arg.stack) {
                    arg = (arg.message && arg.stack.indexOf(arg.message) === -1) ? 'Error: ' + 
                    arg.message + '\n' + arg.stack : arg.stack;
                } else if (arg.sourceURL) {
                    arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
                }
            }
            return '[' + name+ '] ' + arg;
        }

        function consoleLog(type, parent, name) {
            var console = $window.console || {},
                logFn = console[type] || console.log || angular.noop;
            if (logFn.apply) {
                var args = [];
                angular.forEach(parent, function(arg) {
                    args.push(formatError(arg, name));
                });
                logFn.apply(console, args);
            }
        }

        function configure(_conf) {
            if (!_conf.consoleThreshold || !(_conf.consoleThreshold >= 1 && _conf.consoleThreshold <= 5)) {
                _conf.consoleThreshold = 4;
            }
            if (!_conf.httpThreshold || !(_conf.httpThreshold >= 1 && _conf.httpThreshold <= 5)) {
                _conf.httpThreshold = 1;
            }
            var keys = Object.keys(config);
            angular.forEach(keys, function (item) {
                if(_conf[item]){
                    config[item] = _conf[item];
                }
                
            });
        }

        function setResource(_resouce) {
            resource = _resouce;
        }

        function formatMessage(_type, level, name) {
                return function () {
                    var timestamp = (new Date()).toISOString();
                    var module = rootname;
                    if (name) {
                        module = module + ':' + name;
                    }
                    var log = {
                        root: rootGuid,
                        timestamp: timestamp,
                        message: [].slice.call(arguments) || '',
                        level: _type,
                        url: $location.absUrl(),
                        name: module
                    };
                    if (arguments[0] instanceof Error && window.printStackTrace) {
                        log.stacktrace = window.printStackTrace({
                            e: arguments[0]
                        });
                    }
                    if (config.httpPath && level <= config.httpThreshold) {
                        resource.save(log);
                    }
                    if (level <= config.consoleThreshold) {
                        switch (level) {
                        case 5:
                            consoleLog('debug',arguments, module);
                            break;
                        case 4:
                            consoleLog('log',arguments, module);
                            break;
                        case 3:
                            consoleLog('info',arguments, module);
                            break;
                        case 2:
                            consoleLog('warn',arguments, module);
                            break;
                        case 1:
                            consoleLog('error',arguments, module);
                            break;
                        }

                    }

                };
            }
            /*jshint bitwise: true*/
        function trmrguid() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        return {
            configure: configure,
            $get: ['$resource', '$location', '$window', function($resource, $location,$window) {
                var urlPath = config.httpPath;
                if(config.httpDomain){
                    urlPath = 'http://' + config.httpDomain + urlPath;
                }
                var WS = $resource(urlPath,
                    null, {
                        save: {
                            method: 'POST',
                            headers: {
                                common: {
                                    'x-cobalt-pcid': trmrguid()
                                }
                            }
                        }
                    });
                setResource(WS);
                setInit($window, $location);
                return {
                    debug: formatMessage('debug', 5),
                    log: formatMessage('log', 4),
                    info: formatMessage('info', 3),
                    warn: formatMessage('warn', 2),
                    error: formatMessage('error', 1),
                    getLogger: function(value) {
                        if (arguments.length > 1) {
                            var temp = Array.apply(null, arguments);
                            value = temp.join(':');
                        }
                        return {
                            debug: formatMessage('debug', 5, value),
                            log: formatMessage('log', 4,value),
                            info: formatMessage('info', 3, value),
                            warn: formatMessage('warn', 2, value),
                            error: formatMessage('error', 1, value)
                        };
                    }

                };
            }]
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.PromiseUtils', PromiseUtils);
    PromiseUtils.$inject = ['$q', '$timeout', 'fef.Utils'];

    function Throttler($q, $timeout, utils, invokeFunc, throttleDelay) {
        /// <summary>[Private] Internal implementation of fef.PromiseUtils.throttle</summary>
        /// <param name="$q" type="$q"></param>
        /// <param name="throttleDelay" type="Number"></param>
        /// <param name="invokeFunc" type="Function"></param>

        this._counter = 0;
        this.invoke = function(arg) {
            /// <signature>
            /// <summary>Kicks off the throttled action after the specified delay,
            /// but only if another invoke is not called again prior to the end of the delay.</summary>
            /// <returns type="Promise">A promise that is resolved if the invokeFunc is executed
            /// as a result of THIS invoke, else rejected if another invoke call cancels this one</returns>
            /// </signature>
            var self = this;
            var _deferred = $q.defer();
            if (!utils.exists(throttleDelay) || throttleDelay === 0) {
                invokeFunc(arg);
                _deferred.resolve({});
            } else {
                // works best for throttleDelays large enough to eliminate
                // the possibility of Number overflow.
                var _curCounter = self._counter + 1;
                this._counter = _curCounter;
                $timeout(function() {
                    if (_curCounter === self._counter) {
                        invokeFunc(arg);
                        _deferred.resolve({});
                    } else {
                        _deferred.reject({});
                    }
                }, throttleDelay);
            }
            return _deferred.promise;
        };
    }

    function PromiseUtils($q, $timeout, utils) {
        /// <param name="$q" type="$q" />

        this.parseRetryInfoJSON = function(statusCode, retryInfoJSON) {
            /// <signature>
            /// <summary>Utility to parse retry information from JSON in a common
            ///  format. </summary>
            /// <param name="statusCode" type="number" />
            /// <param name="retryInfoJSON" type="String" />
            /// <returns type="Object">The parsed retry information</returns>
            /// </signature>
            var ret = {
                retry: utils.exists(statusCode) && (statusCode === '503' || statusCode === 503)
            };

            if (utils.stringIsNonBlank(retryInfoJSON)) {
                try {
                    var body = JSON.parse(retryInfoJSON);
                    if (utils.exists(body)) {
                        if (utils.exists(body.retry)) {
                            ret.retry = (body.retry ? true : false) || ret.retry;
                        }
                        if (angular.isNumber(body.retryInMs)) {
                            ret.retryInMs = body.retryInMs;
                        }
                    }
                } catch (e) {
                    ret = null;
                }
            }
            return ret;
        };

        this.throttle = function(invokeFunc, throttleDelay) {
            /// <signature>
            /// <summary>Creates a Throttler object with an invoke function which
            /// you can call multiple times (e.g. in response to an ngChange event).
            /// The invokeFunc you pass in will be called, but only after throttleDelay,
            /// and only if no other invoke call is made within that time. Use this to,
            /// for instance, throttle live search requests or auto-fill services.
            /// </summary>
            /// <param name="invokeFunc" type="Function">The function to be executed.</param>
            /// <param name="throttleDelay" type="number">The amount of time in ms to wait before
            /// calling invokeFunc.</param>
            /// <returns type="fef.Throttler">An object with an invoke function which can be
            ///  called multiple times within throttleDelay, but results in only one call of
            ///  invokeFunc for that time window.</returns>
            /// </signature>

            return new Throttler($q, $timeout, utils, invokeFunc, throttleDelay);
        };

        this.resolvedPromise = function(value, delay) {
            /// <signature>
            /// <summary>Utility to get a resolved promise, optionally after
            ///   delay.</summary>
            /// <param name="value" type="Object">The value to resolve with.</param>
            /// <param name="delay" type="number" optional="true">Optional delay, in ms. If
            ///  no delay given, the returned promise will be resolved immediately.</param>
            /// <returns type="Promise">A Promise that will resolve with the exact
            ///  value you specify. If you specify a delay, the promise will be resolved
            ///  asynchronously after the delay you specify, in ms.</returns>
            /// </signature>
            var _resolvedPromiseImpl = function(_value) {
                var d = $q.defer();
                d.resolve(_value);
                return d.promise;
            };

            if (!utils.exists(delay)) {
                return _resolvedPromiseImpl(value);
            } else {
                return $timeout(function() {}, delay).then(function() {
                    return _resolvedPromiseImpl(value);
                });
            }
        };

        this.retry = function(retryFunc, retryCount, promise, parseRetryFunc) {
            /// <signature>
            /// <summary>Utility to attempt an action, and retry that action up to retryCount times
            ///  if unsuccessful.</summary>
            /// <param name="retryFunc" type="Function">A function which returns a promise. This
            ///  function will be called once initially, if you don't specify an initial promise,
            ///  and once afterward for each retry attempt.</param>
            /// <param name="retryCount" type="number">The number of times to retry the retryFunc.</param>
            /// <param name="promise" type="Promise">If you have an existing promise you'd like
            ///  to retry, pass it along here. Otherwise, pass null and retryFunc will be
            ///  called once to create the initial promise. </param>
            /// <param name="parseRetryFunc(error_Object)" type="Function">A function taking a single
            ///  argument (the error value of the promise) and returns a normalized retry info object,
            ///  used to determine whether to retry or not.</param>
            /// <returns type="Promise">A promise that resolves with the value of the original promise,
            ///  if successful after the retry attempts, else it returns the error result of the last
            ///  retry attempt promise.</returns>
            /// </signature>
            var self = this;

            // default retryCount to 2
            if (!utils.exists(retryCount) || !angular.isNumber(retryCount)) {
                retryCount = 2;
            }

            // create the promise if it doesn't exist already. This makes
            // it so the calling code can pass an anonymous function for
            // retryFunc, which is convenient.
            if (!utils.exists(promise)) {
                promise = retryFunc();
            }

            // use a reasonable default retry info parser
            if (!utils.exists(parseRetryFunc)) {
                parseRetryFunc = function(value) {
                    if (angular.isString(value)) {
                        return self.parseRetryInfoJSON(value);
                    } else {
                        return value;
                    }
                };
            }

            // if we have no more retries, then we'll return the original promise
            var ret = promise;
            if (retryCount > 0) {
                // we have some retries left, so intercept errors and retry if
                // the error indicates the request can be retried.
                ret = ret.then(null, function(error) {
                    var retryInfo = parseRetryFunc(error);
                    if (utils.exists(retryInfo)) {
                        // error response indicates we should attempt to retry
                        if (utils.exists(retryInfo.retryInMs) && typeof retryInfo.retryInMs === 'number') {
                            // delay the retry by the amount specified in the error response
                            return $timeout(function() {}, retryInfo.retryInMs).then(
                                function() {
                                    return self.retry(retryFunc, retryCount - 1, retryFunc(), parseRetryFunc);
                                });
                        } else {
                            // no explicit retry time specified in the response, so retry immediately
                            return self.retry(retryFunc, retryCount - 1, retryFunc(), parseRetryFunc);
                        }
                    } else {
                        // assume not a retryable error, throw it again.
                        return $q.reject(error);
                    }
                });
            } // else, we return the promise directly.
            return ret;
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.SanityChecks', SanityChecks);
    SanityChecks.$inject = [];

    function SanityChecks() {
        /**
         * @ngdoc method
         * @name fef.SanityChecks#checkConstructorUsage
         * @description Throws an error if the constructor function was called without
         * the new keyword. This could lead to inadvertently assigning global variables.
         *
         * @param {Object} _this Pass 'this' from the constructor function.
         * @param {function} constructor Pass a reference to the constructor function.
         */
        this.checkConstructorUsage = function(_this, constructor) {
            if (!(_this instanceof constructor)) {
                throw new Error('Constructor called as a function');
            }
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.Utils', Utils);
    Utils.$inject = [];

    function Utils() {
        var self = this;
        this.guid = function() {
            /// <summary>Creates a random guid string</summary>
            /// <returns type='String' />
            var s4 = function() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            };
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };

        this.exists = function(value) {
            /// <signature>
            /// <summary>Utility to check if a value is defined and non-null.</summary>
            /// <param name='value' type='Object' />
            /// <returns type='Boolean'>True, if value is defined and non-null.
            ///  False otherwise.</returns>
            /// </signature>
            return typeof value !== 'undefined' && value !== null;
        };

        // TODO: stringIsNonBlank and stringReplaceAll - should we move these to a new StringUtils service?

        this.stringIsNonBlank = function(value) {
            /// <signature>
            /// <summary>Utility to check if a value is a defined and non-null string
            /// with non-zero length.</summary>
            /// <param name='value' type='String' />
            /// <returns type='Boolean'>True, if value is defined and non-null and a string
            /// of length greater than zero. False otherwise.</returns>
            /// </signature>
            return typeof value === 'string' && value.length > 0;
        };

        this.stringReplaceAll = function(sourceString, find, replace) {
            /// <signature>
            /// <summary>This is a global replace all within a string. Use this in
            /// place of the built-in function on strings when you want to replace all
            /// instances instead of the first one.</summary>
            /// <param name='sourceString' type='String'>The source string you want to work on.</param>
            /// <param name='find' type='String'>The substring to replace from sourceString.</param>
            /// <param name='replace' type='String'>The string to replace find with.</param>
            /// </signature>
            if (!self.exists(sourceString) || !self.exists(find) || !self.exists(replace)) {
                throw new Error('fef.Utils.stringReplaceAll: invalid argument(s)');
            }
            return sourceString.replace(new RegExp(find, 'g'), replace);
        };

        this.toBoolean = function(value) {
            /// <signature>
            /// <summary>Very lenient string-to-boolean converter.</summary>
            /// <param name='value' type='String' />
            /// <returns type='Boolean'></returns>
            /// </signature>
            if (value && value.length !== 0) {
                var v = ('' + value).toLowerCase();
                value = !(v === 'f' || v === '0' || v === 'false' || v === 'no' || v === 'n' || v === '[]');
            } else {
                value = false;
            }
            return value;
        };

        this.nonEmptyStrings = function(array) {
            /// <summary>Creates a new array of strings from an existing array by filtering
            ///  out all null, undefined, empty string, and non-string values from the
            ///  original array.</summary>
            /// <param name='array' type='Array'>The original array.</param>
            /// <returns type='Array'>A new Array.</returns>

            return array.filter(this.stringIsNonBlank);
        };

        this.joinNonEmptyStrings = function(prefix, separator, args) {
            /// <summary>Creates a string out of an array of strings by first filtering out
            ///  the empty and non-string values of the original array, and if there are
            ///  any remaining strings in the array, prefixes the result with the specified
            ///  prefix, followed by the join of the remaining non-empty strings using
            ///  the specified separator. If no strings are left after filtering, an empty
            ///  string is returned.</summary>
            /// <param name='prefix' type='String'>The desired prefix of the result.</param>
            /// <param name='separator' type='String'>The desired separator to use when joining the
            ///  remaining non-empty strings after the prefix.</param>
            /// <param name='args' type='Array'>The original array.</param>
            /// <returns type='String'>A new string.</returns>
            var ret = '';
            if (!this.exists(prefix) || !this.exists(separator) || !this.exists(args)) {
                throw 'fef.Utils.joinNonEmptyStrings: arguments must not be null.';
            }
            if (!angular.isString(prefix) || !angular.isString(separator)) {
                throw 'fef.Utils.joinNonEmptyStrings: prefix and separator arguments must be strings.';
            }
            if (!angular.isArray(args)) {
                throw 'fef.Utils.joinNonEmptyStrings: args must be an array.';
            }
            var filtered = this.nonEmptyStrings(args);
            if (filtered.length > 0) {
                ret = prefix + filtered.join(separator);
            }
            return ret;
        };
    }

}());
